<template>
  <div class="article">
    <!-- <router-link
      class="edit"
      v-if="isAuthenticated"
      :to='{name: "book-edit", params: {slug: book.slug}}'>
      bearbeiten
      <i class="material-icons">edit</i>
    </router-link> -->
    <RwvPost
      :post="article"
      :isBook="false"
      :isLightTheme="article.isLightTheme"></RwvPost>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import store from "@/store";
import RwvPost from "@/components/Posts/Post";
import { FETCH_ARTICLE } from "@/store/actions.type";

export default {
  title () {
    return `${this.article.title} | So wird's gemacht`
  },
  components: {
    RwvPost
  },
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.slug == null || to.params.slug == "") {
      console.log("unknown slug")
    }

    Promise.all([
      store.dispatch(
        FETCH_ARTICLE,
        {
          slug: to.params.slug
        }
      ),
    ]).then(() => {
      next();
    });
  },
  computed: {
    ...mapGetters(["article", "isAuthenticated"])
  },
}
</script>

<style lang="scss">
</style>
